export default [
  {
    path: '/sites',
    name: 'sites-read',
    component: () => import('@/views/sites/sites-list/SitesList.vue'),
    meta: {
      resource: 'Sites',
      action: 'read',
    },
  },
  {
    path: '/sites/create',
    name: 'sites-create',
    component: () => import('@/views/sites/sites-form/SitesForm.vue'),
    meta: {
      resource: 'Sites',
      action: 'create',
    },
  },
  {
    path: '/site-type',
    name: 'site-types-read',
    component: () => import('@/views/sites/site-types-list/SiteTypesList.vue'),
    meta: {
      resource: 'Sites',
      action: 'read',
    },
  },
  {
    path: '/site-type/create',
    name: 'site-type-create',
    component: () => import('@/views/sites/sites-form/SitesForm.vue'),
    meta: {
      resource: 'Sites',
      action: 'create',
    },
  },
  {
    path: '/destinations',
    name: 'destinations-read',
    component: () => import('@/views/sites/destination/DestinationList.vue'),
    meta: {
      resource: 'Destinations',
      action: 'read',
    },
  },
  {
    path: '/destinations/create',
    name: 'destinations-create',
    component: () => import('@/views/sites/destination/DestinationForm.vue'),
    meta: {
      resource: 'Destinations',
      action: 'create',
    },
  }
]